'use strict';

var React = require('react');

var PublicationTime = require('../elements/PublicationTime.jsx');


var AuthorImage = React.createClass({
	displayName: 'AuthorImage',

	render: function() {
		if (!this.props.item.avatar) {
			return false;
		}

		var item = this.props.item;

		return (
			<img className="svtse_editorial-byline__cover" src={item.avatar} alt={item.name} />
		);
	}

});

var AuthorEmail = React.createClass({
	displayName: 'AuthorEmail',

	render: function() {
		if (!this.props.email) {
			return false;
		}

		var email = this.props.email;
		var mailTo = "mailto:" + email;

		return (
			<a href={mailTo} className="svtse_editorial-byline__email">{email}</a>
		);
	}

});


var Author = React.createClass({
	displayName: 'ArticleTextContentAuthor',

	render: function() {
		if (!this.props.model || !this.props.model.length) {
			return false;
		}

		var model = this.props.model;

		return (
			<div className="svtse_editorial-byline">
				{model.map(function(item, index) {
					return (
						<div className="svtse_editorial-byline__author" key={index}>
							<AuthorImage item={item} />
							<div className="svtse_editorial-byline__body">
								<span className="svtse_editorial-byline__name">{item.name}</span>
								<AuthorEmail email={item.email} />
							</div>
						</div>
					);
				})}
			</div>
		);
	}

});

var Published = React.createClass({
	render: function() {
		if (!this.props.timestamp) {
			return false;
		}

		return (
			<div className="svtse_editorial-date">
				<div className="svtse_editorial-date__body">
					Publicerad: <PublicationTime dateTime={this.props.timestamp}/>
				</div>
			</div>
		);
	}
});


module.exports = React.createClass({
	displayName: 'ArticleTextContent',

	render: function () {
		var article = this.props.article;

		if (!article) {
			return false;
		}

		// dangerouslySetInnerHTML throws an error if the text is missing.
		var mainText = article.body || '';

		return (
			<div className="svtse_editorial__text">
				<p className="svtse_editorial__text-byline">
					{article.leadText}
				</p>

				<div className="svtse_editorial__text-bread" dangerouslySetInnerHTML={{__html: mainText}} />

				<div className="svtse_editorial__footer">
					<div className="svtse_editorial__footer-cell">
						<Author model={article.byline}/>
					</div>
					<div className="svtse_editorial__footer-cell">
						<Published timestamp={article.publishedDate} />
					</div>
				</div>

			</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/Editorial/EditorialTextContent.jsx
 **/